import { api, projectApi } from "../../services";
import { $config } from "../../conf";
export let commonApi = {
  /**
   * 获取系统当前时间
   * */
  getNow() {
    return projectApi.request("/get_time");
  },
};
